export const isMarket = (markets: string | string[]) => {
    if (typeof markets === 'string') {
        markets = [markets];
    }

    return markets.includes(process.env.REACT_APP_MARKET!);
}